function WideContainer({children, id}){
    return (
        <div className="px-4 py-3 my-4 text-center container-wide box-shadow" id={id}>{children}</div>
    );
}

export default WideContainer;